// extracted by mini-css-extract-plugin
module.exports = {"resultRowWrapper":"ResultRow_resultRowWrapper__AY3Op"};